import { TextField, MenuItem, CircularProgress, Box } from "@mui/material";
import { School } from "../../../../interfaces";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

type SchoolSelectProps = {
  schoolId: string;
  onChange: (id: string) => void;
  options: School[];
  required?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
};

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function SchoolSelect(props: SchoolSelectProps) {
  const emptyAndDisabled = !props.schoolId && props.disabled;
  const classes = useStyle();
  const { isLoading = false } = props;
  return (
    <TextField
      className={classes.inputText}
      value={props.schoolId}
      onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disabled}
      label="School"
      InputLabelProps={{
        shrink: emptyAndDisabled || undefined,
      }}
      SelectProps={{
        displayEmpty: true,
        // Renders 'N/A' without actually setting the value
        renderValue: emptyAndDisabled ? () => "N/A" : undefined,
      }}
      required={props.required}
      fullWidth
      select>
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {props.options.map((school) => (
        <MenuItem key={school.id} value={school.id}>
          {school.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
